import List from "@material-ui/core/List"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import SideListItem from "./SideListItem"
import { Menu } from "Types/menu"

const SideList = () => {
    const { mainList } = useContext(AppContext)
    return (
        <List>
            {mainList.map((item: Menu) => (<SideListItem key={item!.id} menu={item} />))}
        </List>
    )
}

export default SideList

